import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            精彩预告
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            试看精选内容
          </h2>
          <p className="mt-2 text-sm text-foreground-600">热门影片预告与深度解析</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div key={item.id} className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden">
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`${item.title} - 6080新视觉影视`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-950/55 backdrop-blur-sm flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/65 text-background-50 text-xs font-mono">
                  {item.duration}
                </span>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-950/50 backdrop-blur-sm text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 mt-2">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}